<template>
  <div class="flex flex-column top">
    <div v-if="!selectedCriteria.length" class="flex flex-column top">
      <div :class="['flex flex-row top', $style.criteriaContainer]">
        <div><p>No criteria selected</p></div>
      </div>
    </div>
    <div v-else class="flex flex-column top">
      <GripAnalysisCriteria :selectedCriteria="selectedCriteria" />
    </div>
    <div
      :class="[
        'flex flex-column top',
        isDataCollector ? 'height-auto' : 'height-100',
      ]"
    >
      <GripAnalysisBarriers
        v-if="selectedCriteria.length > 0"
        :projectId="projectId"
        :isDataCollector="isDataCollector"
        :gripAnalysisDetails="gripAnalysisDetails"
        :isSideBarOpen="isSideBarOpen"
        :updatedItem="updatedItem"
        @addGripAnalysisBarrier="handleAddGripAnalysisBarrier"
        @updateGripAnalysisBarrier="handleUpdateGripAnalysisBarrier"
        @deleteGripAnalysisBarrier="handleDeleteGripAnalysisBarrier"
        @addGripAnalysisEnabler="handleAddGripAnalysisEnabler"
        @updateGripAnalysisEnabler="handleUpdateGripAnalysisEnabler"
        @deleteGripAnalysisEnabler="handleDeleteGripAnalysisEnabler"
        @addGripAnalysisStrategy="handleAddGripAnalysisStrategy"
        @updateGripAnalysisStrategy="handleUpdateGripAnalysisStrategy"
        @deleteGripAnalysisStrategy="handleDeleteGripAnalysisStrategy"
        @handleUpdatedItemReload="handleUpdatedItemReload"
      />
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import BaseLoading from '../../../components/base/BaseLoading.vue';
import { ProjectCriteria } from '../../../store/modules/projects/types/projects.types';
import {
  CreateGripAnalysisBarrierPayload,
  CreateGripAnalysisEnablerPayload,
  CreateGripAnalysisStrategyPayload,
  GripAnalysisDTO,
  GripItemReloadDTO,
  UpdateGripAnalysisBarrierPayload,
  UpdateGripAnalysisEnablerPayload,
  UpdateGripAnalysisStrategyPayload,
} from '../../../store/types/grip.types';
import GripAnalysisBarriers from './GripAnalysisBarriers.vue';
import GripAnalysisCriteria from './GripAnalysisCriteria.vue';

@Component({
  components: { BaseLoading, GripAnalysisCriteria, GripAnalysisBarriers },
})
export default class GripAnalysisDetails extends Vue {
  @Prop() public projectId!: number;
  @Prop() public isDataCollector!: boolean;
  @Prop() public isSideBarOpen!: boolean;
  @Prop() public gripAnalysisDetails!: GripAnalysisDTO;
  @Prop() public selectedCriteria!: ProjectCriteria[];
  @Prop() public updatedItem!: GripItemReloadDTO;

  public handleUpdateGripAnalysis(): void {
    this.$emit('updateGripAnalysis');
  }

  public handleAddGripAnalysisBarrier(barrierDetails: {
    barrierPayload: CreateGripAnalysisBarrierPayload;
    isNew: boolean;
  }): void {
    this.$emit('addGripAnalysisBarrier', barrierDetails);
  }

  public handleUpdateGripAnalysisBarrier(
    barrierPayload: UpdateGripAnalysisBarrierPayload,
  ): void {
    this.$emit('updateGripAnalysisBarrier', barrierPayload);
  }

  public handleDeleteGripAnalysisBarrier(gripAnalysisBarrierId: number): void {
    this.$emit('deleteGripAnalysisBarrier', gripAnalysisBarrierId);
  }

  public handleAddGripAnalysisEnabler(enablerDetails: {
    enablerPayload: CreateGripAnalysisEnablerPayload;
    isNew: boolean;
  }): void {
    this.$emit('addGripAnalysisEnabler', enablerDetails);
  }

  public handleUpdateGripAnalysisEnabler(
    enablerPayload: UpdateGripAnalysisEnablerPayload,
  ): void {
    this.$emit('updateGripAnalysisEnabler', enablerPayload);
  }

  public handleDeleteGripAnalysisEnabler(gripAnalysisEnablerId: number) {
    this.$emit('deleteGripAnalysisEnabler', gripAnalysisEnablerId);
  }

  public handleAddGripAnalysisStrategy(strategyDetails: {
    strategyPayload: CreateGripAnalysisStrategyPayload;
    isNew: boolean;
  }): void {
    this.$emit('addGripAnalysisStrategy', strategyDetails);
  }

  public handleUpdateGripAnalysisStrategy(
    strategyPayload: UpdateGripAnalysisStrategyPayload,
  ): void {
    this.$emit('updateGripAnalysisStrategy', strategyPayload);
  }

  public handleDeleteGripAnalysisStrategy(
    gripAnalysisStrategyId: number,
  ): void {
    this.$emit('deleteGripAnalysisStrategy', gripAnalysisStrategyId);
  }

  public handleUpdatedItemReload(data: GripItemReloadDTO): void {
    this.$emit('handleUpdatedItemReload', data);
  }
}
</script>
<style lang="scss" module>
.criteriaContainer {
  justify-content: center;
  padding: 20px 16px;
  width: 100%;
  left: 0px;
  top: 0px;
}
</style>
